import React from 'react'
import './index.less'

class Goods extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {data, currencySymbol,} = this.props
        return (
            <div className="cancelRecord-goods mt_16 pr_28" data-flex="cross:top">
                <img src={data.picUrl} alt=""/>
                <div className="flex1 ml_12">
                    <p className="font-title lineH_20 mb_8" data-flex="cross:baseline">
                                <span className="flex1 font_14">
                                    {data.skuName}
                                </span>
                    </p>

                    <p className="con2-txt font_12 lineH_18 mb_6">
                        <span className="mr_24">{__getServerLanguage('ZhuangLiang')}  {data.outboxCapacity}/{__getServerLanguage('WaiXiang')}</span>
                        <span>{__getServerLanguage('CaiGouJia')}  {data.purchasePrice} {currencySymbol}</span>
                    </p>

                    <p className="con2-txt font_12 lineH_18">
                        <span className="mr_24">{__getServerLanguage('TiJi')}  {data.outBoxVolume} m³</span>
                        <span>{__getServerLanguage('ShangPinBianHao')}  {data.skuNo}</span>
                    </p>
                </div>
            </div>
        )
    }
}

Goods.defaultProps = {
    data: {},
    currencySymbol: '', // 当前币种
}

export default Goods
